export default __webpack_public_path__ + "static/console-events-detail-screen-4ac1291bee27fafe75353e87ce050231.png";